import { Button } from '../Button'
import { ButtonProps } from '../Button/Types'
import { ReactComponent as MergeIcon } from './merge16.svg'
import Styles from './MergeButton.module.scss'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'

export const MergeButton = (props: ButtonProps) => (
  <Button
    {...props}
    frontIcon={MergeIcon}
    className={ItemStyles.controlItem}
    iconClassName={Styles.mergeIcon}
    variant="tertiary"
    size="sm"
  >
    Merge
  </Button>
)
